export default __webpack_public_path__ + "assets/logo.b3679217fa4d9f32aeda0759e3c48849.png";